export const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  return `${day}-${month}-${year}`;
};

const base64ToFile = (input, fileName) => {
  if (input.startsWith("http") || input.startsWith("blob:")) {
    return input; // Return URL as is
  }
  
  // Extract the mime type from base64 string
  let arr = input.split(",");
  let mimeMatch = arr[0].match(/:(.*?);/);
  if (!mimeMatch) return null; // Invalid base64 format
  let mime = mimeMatch[1];

  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};


export const saveAsDraft = async ({
  ProjectRouter,
  setDraftLoader,
  navigate,
  roofInfo,
  quantityInfo,
  user,
  structureImage,
  reportInfo,
}) => {
  setDraftLoader(true);
  const projectId = sessionStorage.getItem("projectId");
  const checkEnum = user?.roles[0].enums;
  const companyId = user?.company_id?._id;
  const projectData = new FormData();

  const statusInfo = {
    status: "Draft",
    updateDate: new Date(),
  };

  const disclaimerInfo = {
    disclaimerTermsCondition: reportInfo?.disclaimerTermsCondition,
    companyAddress: reportInfo?.companyAddress,
    companyPhoneNo: reportInfo?.companyPhoneNo,
    companyEmail: reportInfo?.companyEmail,
  };

  if (!projectId) {
    projectData.append("authId", user?._id);
    projectData.append("companyId", companyId);
    projectData.append("createdBy", user?._id);
  }
  projectData.append("statusInfo", JSON.stringify(statusInfo));
  projectData.append("status", "DRAFT");
  projectData.append("customerName", roofInfo?.value?.customerName);
  projectData.append("siteAddress", roofInfo?.value?.siteAddress?.value);
  projectData.append("siteName", roofInfo?.value?.siteName);
  projectData.append("designer", user?.name);
  projectData.append("companyName", reportInfo?.companyName);
  if (reportInfo?.companyLogo) {
    const companyURL = base64ToFile(reportInfo?.companyLogo, "companyLogo");
    projectData.append("companyLogo", companyURL);
  }
  projectData.append("date", new Date());
  projectData.append("quantityInfo", JSON.stringify(quantityInfo));
  projectData.append("value", JSON.stringify(roofInfo?.value));
  projectData.append("inverterInfo", {});
  projectData.append("structureInfo", {});
  if (reportInfo) {
    projectData.append("disclaimerInfo", JSON.stringify(disclaimerInfo));
  }

  const RemoveItem = [
    "projects",
    "cid",
    "customerName",
    "projectId",
    "roofPolygons",
    "structureItem",
    "myData",
    "imageSrc",
    "ImageSrc",
  ];
  if (checkEnum === "DESIGNER") {
    const adminID = user?.createdBy;
    projectData.append("adminId", adminID);
  }
  if (structureImage) {
    const reportURL = base64ToFile(structureImage, "reportImage");
    projectData.append("reportUrl", reportURL);
  }

  if (
    !roofInfo.value.siteName &&
    !roofInfo.value.siteAddress.value &&
    !roofInfo.value.customerName
  ) {
    RemoveItem.forEach((key) => {
      sessionStorage.removeItem(key);
    });
    navigate("/dashboard");
  } else {
    if (projectId) {
      // delete projectData.companyId;
      const res = await ProjectRouter.update(projectData, projectId);
      if (res) {
        RemoveItem.forEach((key) => {
          sessionStorage.removeItem(key);
        });
        navigate("/dashboard");
      }
    } else {
      const res = await ProjectRouter.create(projectData);
      if (res) {
        RemoveItem.forEach((key) => {
          sessionStorage.removeItem(key);
        });
        navigate("/dashboard");
      }
      setDraftLoader(false);
    }
  }
};

export const submitProject = async ({
  ProjectRouter,
  setSubmitLoader,
  navigate,
  roofInfo,
  quantityInfo,
  user,
  structureImage,
  reportInfo
}) => {
  setSubmitLoader(true);
  const checkEnum = user?.roles[0].enums;
  const companyId = user?.company_id?._id;
  const projectId = sessionStorage.getItem("projectId");

  const projectData = new FormData();
  const statusInfo = {
    status: "Pending",
    updateDate: new Date(),
  };

  const disclaimerInfo = {
    disclaimerTermsCondition: reportInfo?.disclaimerTermsCondition,
    companyAddress: reportInfo?.companyAddress,
    companyPhoneNo: reportInfo?.companyPhoneNo,
    companyEmail: reportInfo?.companyEmail,
  };

  if (!projectId) {
    projectData.append("authId", user?._id);
    projectData.append("companyId", companyId);
    projectData.append("createdBy", user?._id);
  }

  projectData.append("statusInfo", JSON.stringify(statusInfo));
  projectData.append("status", "PENDING");
  projectData.append("customerName", roofInfo?.value?.customerName);
  projectData.append("siteAddress", roofInfo?.value?.siteAddress?.value);
  projectData.append("siteName", roofInfo?.value?.siteName);
  projectData.append("companyName", reportInfo?.companyName);
  if (reportInfo?.companyLogo) {
    const companyURL = base64ToFile(reportInfo?.companyLogo, "companyLogo");
    projectData.append("companyLogo", companyURL);
  }
  projectData.append("designer", user?.name);
  projectData.append("date", new Date());
  projectData.append("quantityInfo", JSON.stringify(quantityInfo));
  projectData.append("value", JSON.stringify(roofInfo?.value));
  projectData.append("inverterInfo", {});
  projectData.append("structureInfo", {});
  projectData.append("disclaimerInfo", JSON.stringify(disclaimerInfo));

  if (structureImage) {
    const reportURL = base64ToFile(structureImage, "reportImage");
    projectData.append("reportUrl", reportURL);
  }

  const RemoveItem = [
    "projects",
    "cid",
    "customerName",
    "projectId",
    "roofPolygons",
    "structureItem",
    "myData",
    "imageSrc",
    "ImageSrc",
  ];
  if (checkEnum === "DESIGNER") {
    const adminID = user?.createdBy;
    projectData.append("adminId", adminID);
  }
  if (projectId) {
    projectData.delete("companyId");
    const res = await ProjectRouter.update(projectData, projectId);

    if (res) {
      RemoveItem.forEach((key) => {
        sessionStorage.removeItem(key);
      });
      setSubmitLoader(false);
      navigate("/dashboard");
    }
  } else {
    const res = await ProjectRouter.create(projectData);
    if (res) {
      RemoveItem.forEach((key) => {
        sessionStorage.removeItem(key);
      });
      setSubmitLoader(false);
      navigate("/dashboard");
    }
  }
};
